export const MODAL_MISSING_DIGITAL_PAYMENT_INFO_FALLBACK_KEY =
  'missing-digital-payment-info-fallback'

export type ModalKey = typeof MODAL_MISSING_DIGITAL_PAYMENT_INFO_FALLBACK_KEY

export interface Modal {
  key: ModalKey
  label: string
}

export type ModalsMap = { [key: string]: Modal }

export type ModalSlice = Modal | null
